import { createSelector } from 'reselect';
import { toJSTyped } from '../../../../utils/immutable/toJSTyped';
import { getAuth } from '../getAuth';
export const getAuthAsPojo = createSelector([getAuth], auth => toJSTyped(auth));